module.exports = __webpack_public_path__ + "static/media/157.2afd6639.jpg";